document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);

  const introSection = document.querySelector('.s-intro');

  if (introSection) {
    const title = introSection.querySelector(".s-intro__title");
    const introImage = introSection.querySelector('.s-intro__main-image');
    const quoteBlock = introSection.querySelector('.s-intro__quote');
    const quoteTexts = introSection.querySelectorAll('.s-intro__quote-top-text, .s-intro__quote-bottom-text');
    const benefitsBlock = introSection.querySelector('.s-intro__benefits');
    const benefits = introSection.querySelectorAll('.s-intro__benefit');
    const button = introSection.querySelector('.s-intro__benefits-link');

    // Section fade-out as you scroll past
    gsap.fromTo(
      introSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: introSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    // Animate title
    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: introSection,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  
    // Image: slide in from left
    if (introImage) {
      gsap.fromTo(
        introImage,
        { x: -50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: introImage,
            start: "top 80%",
            end: "top 60%",
            scrub: true,
          },
        }
      );
    }
  
    // Quote block: slide in from right
    if (quoteBlock) {
      gsap.fromTo(
        quoteBlock,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: quoteBlock,
            start: "top 80%",
            end: "top 60%",
            scrub: true,
          },
        }
      );
    }
  
    // Quote texts: scale and fade in
    if (quoteTexts.length) {
      quoteTexts.forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, scale: 0.95 },
          {
            opacity: 1,
            scale: 1,
            duration: 0.4,
            ease: "back.out(1.7)",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 60%",
              scrub: true,
            },
          }
        );
      });
    }
  
    // Benefits block: fade in and slide from right
    if (benefitsBlock) {
      gsap.fromTo(
        benefitsBlock,
        { y: 40, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: benefitsBlock,
            start: "top 80%",
            end: "top 60%",
            scrub: true,
          },
        }
      );
    }
  
    // Individual benefit items: staggered in with scrub
    if (benefits.length) {
      benefits.forEach((benefit, i) => {
        gsap.fromTo(
          benefit,
          { x: 20, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            duration: 0.4,
            ease: "power2.out",
            scrollTrigger: {
              trigger: benefit,
              start: `top 90%+=${i * 20}`,
              end: `top 70%+=${i * 20}`,
              scrub: true,
            },
          }
        );
      });
    }
  
    // Animate button pop-in
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  ScrollTrigger.refresh();
});
